import React from "react";
import { CALL, callLink } from "@/lib/check";
import { track } from "@/lib/track";

const TONES = {
  dark: "text-white ring-white/30 hover:bg-white/10",
  light: "text-black ring-black/15 hover:bg-black hover:text-white hover:ring-black",
};

// The quieter door beside the main one: a short call, booked on the calendar.
export default function TalkFirst({
  location,
  answers,
  tone = "dark",
  className = "",
}) {
  return (
    <a
      href={callLink(answers)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="talk-first"
      onClick={() => track("cta_fit_call_clicked", { location })}
      className={`inline-flex h-11 shrink-0 items-center gap-2 rounded-full px-6 text-[13px] font-medium ring-1 transition-colors ${TONES[tone]} ${className}`}
    >
      Talk first
      <span className="font-normal opacity-55">{CALL.time}</span>
    </a>
  );
}
